/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type TheGrapefulClubPage_viewer$ref = any;
export type GrapefulClubPage_QueryVariables = {};
export type GrapefulClubPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": TheGrapefulClubPage_viewer$ref;
    }) | null;
};
export type GrapefulClubPage_Query = {
    readonly response: GrapefulClubPage_QueryResponse;
    readonly variables: GrapefulClubPage_QueryVariables;
};



/*
query GrapefulClubPage_Query {
  viewer {
    id
    ...TheGrapefulClubPage_viewer
  }
}

fragment TheGrapefulClubPage_viewer on Viewer {
  id
  ...GrapefulClubPage_viewer
}

fragment GrapefulClubPage_viewer on Viewer {
  id
  isLoggedIn
  user {
    id
    conciergeUser {
      userId
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
      id
    }
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
  }
  ...QuarterlyPicks_viewer
}

fragment QuarterlyPicks_viewer on Viewer {
  id
  wineClub(first: 1000) {
    id
    date {
      quarter
    }
    fullPrice
    price
    image
    description
    priceUSDmin
    priceUSDmax
    products {
      edges {
        node {
          id
          productId
          productURLslug
          name
          price
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "access",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "GrapefulClubPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "TheGrapefulClubPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "GrapefulClubPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "userId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                },
                                (v1 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "wineClub",
                            "storageKey": "wineClub(first:1000)",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1000,
                                    "type": "Int"
                                }
                            ],
                            "concreteType": "WineClub",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "date",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WineClubDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "quarter",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "fullPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "image",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "priceUSDmin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "priceUSDmax",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "products",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WineClubProductConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WineClubProductEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "WineClubProductType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productURLslug",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "name",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "GrapefulClubPage_Query",
            "id": null,
            "text": "query GrapefulClubPage_Query {\n  viewer {\n    id\n    ...TheGrapefulClubPage_viewer\n  }\n}\n\nfragment TheGrapefulClubPage_viewer on Viewer {\n  id\n  ...GrapefulClubPage_viewer\n}\n\nfragment GrapefulClubPage_viewer on Viewer {\n  id\n  isLoggedIn\n  user {\n    id\n    conciergeUser {\n      userId\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n  }\n  ...QuarterlyPicks_viewer\n}\n\nfragment QuarterlyPicks_viewer on Viewer {\n  id\n  wineClub(first: 1000) {\n    id\n    date {\n      quarter\n    }\n    fullPrice\n    price\n    image\n    description\n    priceUSDmin\n    priceUSDmax\n    products {\n      edges {\n        node {\n          id\n          productId\n          productURLslug\n          name\n          price\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c721bd738959c170b313519a3b6666b8';
export default node;
